import { render, staticRenderFns } from "./answerBidderQuestions.vue?vue&type=template&id=67caa19e&scoped=true"
import script from "./answerBidderQuestions.vue?vue&type=script&lang=js"
export * from "./answerBidderQuestions.vue?vue&type=script&lang=js"
import style0 from "./answerBidderQuestions.vue?vue&type=style&index=0&id=67caa19e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67caa19e",
  null
  
)

export default component.exports